const collapseActions = {
  CONTACTS_COLLAPSE_SUCCESS: 'CONTACTS_COLLAPSE_SUCCESS',
  CONTACTS_SHOW_ALL_SUCCESS: 'CONTACTS_SHOW_ALL_SUCCESS',
  ADDRESSES_COLLAPSE_SUCCESS: 'ADDRESSES_COLLAPSE_SUCCESS',
  ADDRESSES_SHOW_ALL_SUCCESS: 'ADDRESSES_SHOW_ALL_SUCCESS',
  ASSIGNMENTS_COLLAPSE_SUCCESS: 'ASSIGNMENTS_COLLAPSE_SUCCESS',
  UNDERWRITING_COLLAPSE_SUCCESS: 'UNDERWRITING_COLLAPSE_SUCCESS',
};

export default collapseActions;
